var Modernizr = require('modernizr');
var queryString = require('query-string');
var pagination = require('imports-loader?jQuery=jquery!../../js/libraries/jquery.simplePagination.js');
require('simplebar');
require('simplebar/dist/simplebar.css');
var exports = (module.exports = {});

var s;
var SearchController = {
  settings: {
    gridWrapper: $('#search-products-grid'),
    filterCheckbox: $('.filter-checkbox'),
    removeFilterButton: $('.remove-filter'),
    dom_removeFilterButton: '.remove-filter',
    mobileSidebarTrigger: '.open-filter-sidebar',
    mobileSidebarFilterWrapper: '.search-filter-sidebar-wrapper'
  },

  init: function() {
    var that = this;
    s = this.settings;
    this.bindUIelement();
    var currentPage = queryString.parse(location.search).page * 1;
    if (window.totalElements) {
      that.initPagination(currentPage);
    }
  },

  toggleParameter: function(filterGroup, filterName, needUrl) {
    var that = this;
    var queryObject = queryString.parse(location.search);

    if (queryObject[filterGroup]) {
      if (queryObject[filterGroup].constructor === Array) {
        //check if present

        if (typeof filterName !== 'string') {
          filterName = filterName.toString();
        }

        let found = queryObject[filterGroup].indexOf(filterName);

        if (found > -1) {
          //remove it from url

          queryObject[filterGroup].splice(found, 1);
        } else {
          //add it to url

          queryObject[filterGroup].push(filterName);
        }
      } else {
        // is string

        if (queryObject[filterGroup] == filterName) {
          //check if already exists
          delete queryObject[filterGroup];
        } else {
          // doesnt exist => we join 2 values into 1 array

          let arr = [];
          arr.push(queryObject[filterGroup]);
          arr.push(filterName);
          queryObject[filterGroup] = arr;
        }
      }
    } else {
      queryObject[filterGroup] = filterName;
    }

    queryObject['page'] = 1;

    //return or not
    this.updateUrl(queryObject);
  },

  updateUrl: function(param) {
    var that = this;
    //update URL
    // console.log(queryString.stringify(param));
    var newUrlQuery = queryString.stringify(param);
    if (history.pushState) {
      window.history.pushState(null, null, '?' + newUrlQuery);
    } else {
      document.location.href = '?' + newUrlQuery;
    }

    // that.addCategory();
    that.replaceProducts(newUrlQuery);
  },

  bindUIelement: function() {
    var that = this;

    /**
     * bind new parameter
     */
    s.filterCheckbox.on('click', function(e) {
      e.preventDefault();

      $('.right-container-wrapper').css('opacity', '.3');
      $('.right-container-wrapper').css('pointer-events', 'none');
      var filterGroup = $(e.currentTarget)
        .attr('group')
        .toLowerCase();
      var filterId = $(e.currentTarget).attr('id');
      var url = $(e.currentTarget).attr('href');

      if ($(e.currentTarget).hasClass('filter-checkbox--active')) {
        that.toggleParameter(filterGroup, filterId, true);
      } else {
        that.toggleParameter(filterGroup, filterId, true);
      }
    });

    $(document).on('click', s.dom_removeFilterButton, function(e) {
      e.preventDefault();
      console.log(e.currentTarget);
      var filterGroup = $(e.currentTarget)
        .attr('data-group')
        .toLowerCase();
      var filterValue = $(e.currentTarget)
        .attr('data-id')
        .toLowerCase();

      // var url = $(e.currentTarget).attr('href');
      that.toggleParameter(filterGroup, filterValue, true);
    });

    if ($(s.mobileSidebarTrigger).length) {
      $(s.mobileSidebarTrigger).on('click', function() {
        $(s.mobileSidebarFilterWrapper).toggleClass('opened');
        $('body').toggleClass('modal-open');
      });

      $('.btn-filter-sidebar-done').on('click', function() {
        $(s.mobileSidebarFilterWrapper).toggleClass('opened');
        $('body').toggleClass('modal-open');
      });

      // $("#backdrop-navbar").on("click", function () {
      //     $('body').removeClass('modal-open');
      //     $(s.mobileSidebarFilterWrapper).removeClass('opened');
      // });
    }
    return false;
  },

  replaceProducts: function(urlQuery) {
    var that = this;

    $.ajax({
      url: '/search/products?' + urlQuery,
      data: {
        ajax: 'true'
      },
      error: function() {
        console.log('error');
      },
      success: function(data) {
        $('#search-products-grid-items').html(data);
        that.updateFilterSidebar();
        that.initPagination();
      },
      type: 'GET'
    });
  },

  updateFilterSidebar: function() {
    var that = this;
    var activeCatArray = queryString.parse(location.search);
    console.log(activeCatArray);
    this.resetFilters();
    $.each(activeCatArray, function(k, value) {
      if ($.isArray(value)) {
        for (var item in value) {
          // console.log(k + " : " + valueArray[item])
          $('.filter-checkbox[group=' + encodeURI(k) + "][id='" + encodeURI(value[item]) + "']").toggleClass(
            'filter-checkbox--active'
          );
        }
      } else {
        $('.filter-checkbox[group=' + encodeURI(k) + "][id='" + encodeURI(value) + "']").toggleClass(
          'filter-checkbox--active'
        );
      }
    });
  },

  initPagination: function(pagenumber) {
    pagenumber = pagenumber ? pagenumber : queryString.parse(location.search).page * 1;

    let query = queryString.parse(location.search);
    delete query['page'];
    let hrefTextPrefix = '?' + queryString.stringify(query) + (query ? '&' : '') + 'page=';

    $('.pagination').pagination({
      items: window.totalElements,
      itemsOnPage: 20,
      displayedPages: 3,
      edges: 1,
      currentPage: pagenumber ? pagenumber : 1,
      cssStyle: 'light-theme',
      hrefTextPrefix: hrefTextPrefix,
      selectOnClick: false,
      nextText: '<i class="fa-right-open-big"></i>',
      prevText: '<i class="fa-left-open-big"></i>'
    });
  },

  resetFilters: function() {
    $('.filter-checkbox').removeClass('filter-checkbox--active');
  }
};

module.exports = SearchController;



// WEBPACK FOOTER //
// ./public/src/js/pages/searchPage.js